import { Injector, ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { NbLayoutModule, NbCardModule } from "@nebular/theme";
import { AuthRoutes } from "./auth.routes";
import { AuthComponent } from "./components/auth.component";

import { AuthBlockComponent } from "./components/auth-block/auth-block.component";
import { LoginComponent } from "./components/login/login.component";
import { LoginTokenComponent } from "./components/login-token/login_token.component";
import { RequestPasswordComponent } from "./components/request-password/request-password.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";

import { APIModule } from "../../api/api.module";
import { LoginKeyComponent } from "./components";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AuthRoutes),
    NbLayoutModule,
    NbCardModule,
    FormsModule,
    APIModule,
  ],
  declarations: [
    AuthComponent,
    AuthBlockComponent,
    LoginComponent,
    LoginTokenComponent,
    LoginKeyComponent,
    RequestPasswordComponent,
    ResetPasswordComponent,
  ],
  exports: [
    AuthComponent,
    AuthBlockComponent,
    LoginComponent,
    LoginTokenComponent,
    RequestPasswordComponent,
    ResetPasswordComponent,
  ],
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts